import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { NotifierModule } from 'angular-notifier';
import { TabsModule } from 'primeng/tabs';
import { TreeModule } from 'primeng/tree';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { AuthModule } from '../features/auth/auth.module';
import { CampaignBannerComponent } from './campaign-banner/campaign-banner.component';
import { SharedModule } from '../shared/shared.module';
import { HomeComponent } from './home/home.component';
import { AfraMagazineComponent } from './home/afra-magazine/afra-magazine.component';
import { TranslateModule } from '@ngx-translate/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificatoinsAndMessagesDropdownComponent } from './header/notificatoins-and-messages-dropdown/notificatoins-and-messages-dropdown.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CallSupportActionButtonComponent } from './call-support-action-button/call-support-action-button.component';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import {
  lucideBell,
  lucideChevronLeft,
  lucideMenu,
  lucideTrash2,
  lucideCheckCheck,
  lucidePhone,
  lucideUser,
  lucideCalendar,
} from '@ng-icons/lucide';
import { EWorkshopsSection } from './home/e-workshops-section/e-workshops-section';
import { CarouselModule } from 'primeng/carousel';

import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    AfraMagazineComponent,
    NotificatoinsAndMessagesDropdownComponent,
    CallSupportActionButtonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    RouterModule,
    NotifierModule,
    TranslateModule,
    AuthModule,
    SharedModule,
    CarouselModule,
    BsDropdownModule,
    BrowserAnimationsModule,
    CollapseModule.forRoot(),
    TabsModule,
    TreeModule,
    MenubarModule,
    MenuModule,
    InfiniteScrollModule,
    NgIconsModule,
    CampaignBannerComponent,
    EWorkshopsSection, // Added EWorkshopsSection to imports
    ButtonModule,
  ],
  providers: [
    provideIcons({
      lucideMenu,
      lucideBell,
      lucideChevronLeft,
      lucideTrash2,
      lucideCheckCheck,
      lucidePhone,
      lucideUser,
      lucideCalendar
    }),
  ],
  exports: [LayoutComponent],
})
export class LayoutModule {}
